/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import type { RouteComponentProps } from '@zcode/router-utils'
import type { Dispatch } from 'redux'
import { selectCityFromRouteProps, selectNeighborhoodFromRouteProps } from '../selectors/router'
import { selectSelectedDistrict } from '../selectors/schoolWidget'
import type { GetState } from '../types'
import loadSchoolWidgetDistricts from './loadSchoolWidgetDistricts'
import { loadSchools } from './loadSchools'

export const loadDistrictsAndSchools =
  (routeProps: RouteComponentProps<{ locationPath: string }>) =>
  async (dispatch: Dispatch, getState: GetState) => {
    const city = selectCityFromRouteProps(routeProps)
    const neighborhood = selectNeighborhoodFromRouteProps(routeProps)

    if (!city) {
      return
    }
    await dispatch(loadSchoolWidgetDistricts({ city, neighborhood }))
    const state = getState()
    const selectedDistrict = selectSelectedDistrict(state)

    if (!selectedDistrict) {
      return
    }

    dispatch(loadSchools(city, selectedDistrict, neighborhood))
  }
